<template>
  <div class="container">
    <div class="sheet-container" v-if="sheetStatus === 1">
      <div class="bg-wrap" v-if="bgUrl">
        <img class="bg" :src="bgUrl" />
        <div class="shadow"></div>
      </div>
      <div class="content-wrap">
        <div class="title-wrap">
          <img class="title" src="@/assets/img/musicSheet/title.png" />
          <img class="wow" src="@/assets/img/musicSheet/wow.png" />
        </div>
        <div class="sheet-wrap">
          <p class="title">{{ sheetName }}</p>
          <p class="singer-list" v-if="singerList.length > 0">
            {{
              singerList
                .map((item) => {
                  return item.name;
                })
                .join("、")
            }}
          </p>
          <p class="inst-list" v-if="instList.length > 0">
            <span v-for="item in instList" :key="item.instrument_id">{{
              item.name
            }}</span>
          </p>
          <div class="sheet-image-wrap">
            <div class="shadow" :style="`height:${sheetShadowHeight}px`"></div>
            <div class="sheet-image" ref="sheet-image">
              <img class="sheet" :src="sheetUrl" />
            </div>
          </div>
        </div>
        <div class="button-wrap" @click="toDownload">
          <div class="btn">下载APP 预览详细内容</div>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="sheetStatus === 0">
      <div class="content">
        <img class="icon" src="@/assets/img/musicSheet/wow-no-data.png" />
        <p class="text">内容已下架</p>
      </div>
    </div>
    <div class="no-data" v-if="sheetStatus === 2">
      <div class="content">
        <img class="icon" src="@/assets/img/musicSheet/wow-no-data.png" />
        <p class="text">歌曲不存在</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sheetStatus: -1,
      bgUrl: "",
      sheetUrl: "",
      sheetName: "",
      singerList: [],
      instList: [],
      sheetShadowHeight: 0,
    };
  },
  mounted() {
    let music_id = Number(this.$route.query.music_id);
    if (!music_id) {
      return false;
    }
    this.$ajax({
      method: "get",
      url:
        process.env.VUE_APP_MS_API +
        "api/v1/music/share_detail?music_id=" +
        music_id,
      headers: {
        "X-DEVICE-TYPE": "4",
        "X-APP-NAME": "musicwow",
      },
    }).then((res) => {
      if (res.data.error_code == 0) {
        this.sheetStatus = 1;
        this.bgUrl = res.data.data.cover_image_url;
        this.sheetUrl = res.data.data.share_image_url;
        this.sheetName = res.data.data.name;
        this.singerList = res.data.data.singer_list;
        this.instList = res.data.data.instrument_list;
        this.$nextTick(() => {
          let ele = this.$refs["sheet-image"];
          this.sheetShadowHeight = ele.offsetHeight + 1;
          // console.log(ele.offsetHeight);
        });
      } else if (res.data.error_code === 31002002) {
        this.sheetStatus = 0;
      } else if (res.data.error_code === 31002001) {
        this.sheetStatus = 2;
      }
    });
  },
  methods: {
    toDownload() {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.conwaysmusic.live";
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: rgb(245, 246, 249);
}
.sheet-container {
  height: 100vh;
  overflow: hidden;
  position: relative;
}
.bg-wrap {
  width: 100%;
  height: auto;
  position: relative;
  font-size: 0;
  img {
    width: 100%;
    height: auto;
  }
  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: linear-gradient(
      180deg,
      rgba(245, 246, 249, 0) 40%,
      rgba(245, 246, 249, 1)
    );
  }
}
.content-wrap {
  position: absolute;
  top: 127px;
  left: 16px;
  right: 16px;
  bottom: 17px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  .title-wrap {
    height: 84px;
    background-image: url(../assets/img/musicSheet/title-bg.png);
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    text-align: right;
    .title {
      width: 145px;
      height: 60px;
      margin: 12px 22px 0 0;
    }
    .wow {
      width: 87px;
      height: auto;
      position: absolute;
      top: 6px;
      left: 58px;
      z-index: 1;
    }
  }
  .sheet-wrap {
    flex: 1;
    height: 0;
    overflow: hidden;
    background-color: #ffffff;
    text-align: left;
    padding: 0 22px;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 16px;
      line-height: 16px;
      color: #181818;
      font-weight: 500;
      margin-top: 20px;
    }
    .singer-list {
      margin-top: 8px;
      color: #9ca1ad;
      font-size: 12px;
      line-height: 12px;
      font-weight: 500;
    }
    .inst-list {
      margin-top: 7px;
      font-size: 0;
      span {
        display: inline-block;
        margin-right: 8px;
        background-color: #ecf7eb;
        border-radius: 9px;
        padding: 3px 8px 2px 8px;
        font-size: 12px;
        line-height: 12px;
        color: #45b13b;
        font-weight: 500;
      }
    }
    .sheet-image-wrap {
      margin-top: 14px;
      flex: 1;
      height: 0;
      position: relative;
      .shadow {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        z-index: 101;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 66%,
          rgba(255, 255, 255, 1)
        );
      }
      .sheet-image {
        max-height: 100%;
        font-size: 0;
        overflow: hidden;
        .sheet {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .button-wrap {
    background-color: #ffffff;
    padding: 7.5px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    .btn {
      height: 59px;
      overflow: hidden;
      background-image: url(../assets/img/musicSheet/button-bg.png);
      background-size: 100% 100%;
      line-height: 61px;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
.no-data {
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  .content {
    text-align: center;
    width: 100%;
    .icon {
      width: 193px;
      margin: 0 0 10px 0;
    }
    .text {
      font-size: 16px;
      line-height: 18px;
      color: #9ca1ad;
      font-weight: 500;
      margin-bottom: 17px;
    }
    // .btn {
    //   display: inline-block;
    //   width: 167px;
    //   height: 59px;
    //   line-height: 59px;
    //   font-size: 16px;
    //   font-weight: 500;
    //   color: #ffffff;
    //   background-image: url(../assets/img/musicSheet/button-bg-s.png);
    //   background-size: 100% 100%;
    // }
  }
}
@media screen and (min-width: 550px) {
  .content-wrap {
    width: 50vw;
    top: 0;
    left: 0;
    right: 0;
    margin: 2.4vw auto 2vw auto;
    bottom: 0;
    .title-wrap {
      height: 11.8vw;
      .title {
        width: 17vw;
        height: 7vw;
        margin: 2.4vw 2vw 0 0;
      }
      .wow {
        width: 12vw;
        height: 14.5vw;
        top: 0.7vw;
        left: 10.5vw;
      }
    }
    .sheet-wrap {
      padding: 0 2vw;
      .title {
        font-size: 2.1vw;
        line-height: 2.1vw;
        margin-top: 2vw;
      }
      .singer-list {
        margin-top: 1.1vw;
        font-size: 1.5vw;
        line-height: 1.7vw;
      }
      .inst-list {
        margin-top: 1.1vw;
        span {
          margin-right: 0.6vw;
          border-radius: 1vw;
          padding: 0.2vw 1vw;
          font-size: 1.1vw;
          line-height: 1.3vw;
        }
      }
      .sheet-image-wrap {
        margin-top: 1.8vw;
      }
    }
    .button-wrap {
      padding: 0.56vw;
      border-bottom-left-radius: 3.9vw;
      border-bottom-right-radius: 3.9vw;
      .btn {
        height: 7.5vw;
        line-height: 7.6vw;
        font-size: 2vw;
      }
    }
  }
  .no-data {
    .content {
      .icon {
        width: 30vw;
        margin: 0 0 1vw 0;
      }
      .text {
        font-size: 2vw;
        line-height: 2vw;
        margin-bottom: 2vw;
      }
    }
  }
}
</style>